export const ChatMode = {
  FULL: "full",
  DM: "dm",
}